import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Component } from 'react';
import { OPTIONGROUP_DISPLAY_NAME } from './constants';

var OptionGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OptionGroup, _Component);

  function OptionGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = OptionGroup.prototype;

  _proto.render = function render() {
    return null;
  };

  return OptionGroup;
}(Component);

_defineProperty(OptionGroup, "displayName", OPTIONGROUP_DISPLAY_NAME);

export default OptionGroup;